import { TFetchConverter } from 'data/types/converter.types';
import { dateConverter } from 'helpers/utils';
import {
  TWorkshopTaskAssigneeDB,
  TWorkshopTaskAssigneeUI,
  TWorkshopTaskDB,
  TWorkshopTaskUI,
  WORKSHOP_TASK_DATE_FORMAT,
} from 'data/types/workshopTasks.types';

export const workshopTaskGetConverter: TFetchConverter<
  TWorkshopTaskUI,
  TWorkshopTaskDB
> = {
  fromDb: data => ({
    id: data.resourceId,
    taskName: data.name,
    order: data.order,
    status: data.status,
    part: data.partType,
    dueDate: data.dueDate
      ? dateConverter(data.dueDate, WORKSHOP_TASK_DATE_FORMAT)
      : '',
    assignee: data.assignedTo ?? '',
    custom: data.custom ?? false,
  }),
};

export const workshopTaskAssigneeGetConverter: TFetchConverter<
  TWorkshopTaskAssigneeUI,
  TWorkshopTaskAssigneeDB
> = {
  fromDb: data => ({
    userId: data.id,
    name: data.fullName,
  }),
};
